<template>
  <BottomDrawer
    :is-shown="state.isShown"
    @close="close"
  >
    <div class="content">
      <div class="failedIcon">
        <div class="gradient failed"/>
      </div>

      <Typography
        variant="v20-700"
        center
        style="margin-top: 8px"
      >
        Что-то не так с оплатой
      </Typography>

      <Typography
        variant="v14-400"
        color="secondary"
        center
      >
        <template v-if="state.pan">
          Не получилось списать деньги с карты *{{ state.pan }}.
        </template>
        <template v-else>
          Не получилось списать деньги с карты
        </template>
        Попробуй ещё раз или добавь другую — вдруг у неё сегодня настроение
        получше 💳
      </Typography>
    </div>

    <div class="modal-divider"/>

    <AppButton
      full-width
      style="margin: 16px 0"
      @click="handlePaymentReTry"
      :loading="state.isSubscriptionLoading"
      :disabled="state.loading"
    >
      Попробовать ещё раз
    </AppButton>

    <!--    @click="handleRemoveCardButtonClick"-->
    <!--    :loading="state.isNewPayLoading"-->
    <!--    :disabled="state.loading"-->

    <AppButton
      full-width
      style="margin: 16px 0"
      variant="secondary"
      @click="state.shownPaymentsCards = true"
      :loading="state.isNewPayLoading"
      :disabled="state.loading"
    >
      <template v-if="state.cardSelected">
        Поменять карту
        <div
          style="background: #4B4B4B; padding: 4px 8px; border-radius: 20px; display: flex; align-items: center; user-select: none"
        >
          <component
            :is="icons.card"
            width="16"
            height="16"
            color="#FFF"
            style="margin-right: 8px"
          />
          •• {{ state.cardSelected.masked_pan.slice(-4) }}
        </div>
      </template>
      <template v-if="!state.cardSelected">
        Поменять карту
      </template>
    </AppButton>
  </BottomDrawer>

  <BottomDrawer
    :is-shown="state.shownPaymentsCards"
    :title="'Способ оплаты'"
    :close-on-click-away="!state.isCardSelecting"
    @close="state.shownPaymentsCards = false"
  >
    <div class="selectCard">
      <div
        class="cardItem"
        v-for="card in state.cards"
      >
        <AppButton
          full-width
          variant="transparent"
          @click="state.cardSelected = card"
          style="display: flex; padding: 14px 0 14px 14px; gap: 12px"
        >
          <div class="check" :class="{checked: state.cardSelected === card}">
            <component
              v-if="state.cardSelected === card"
              :is="icons.CheckIcon"
              width="14"
              height="14"
              color="#FFF"
              style="flex-shrink: 0"
            />
          </div>
          <component
            :is="icons.card"
            width="24"
            height="24"
            color="#A6A5A5"
            style="margin-right: 8px"
          />
          <Typography
            left
            variant="v14-600"
            style="flex-grow: 1"
          >
            •• {{ card.masked_pan.slice(-4) }}
          </Typography>
          <AppButton
            v-if="state.cards.length >= 2 || store.getters['user/currentSubscription']?.next_payment_attempt_at"
            variant="transparent"
            @click="(e) => {e.stopPropagation(); state.shownDeleteCard = card}"
          >
            <component
              :is="icons.cancel"
              width="24"
              height="24"
              color="#838181"
            />
          </AppButton>
        </AppButton>
      </div>
    </div>
    <div class="buttons">
      <AppButton
        full-width
        style="margin-top: 16px"
        variant="primary"
        @click="selectCard()"
        :disabled="state.isCardSelecting"
        :loading="state.isCardSelecting"
      >
        Выбрать
      </AppButton>
      <AppButton
        full-width
        style="margin-top: 16px"
        variant="secondary"
        @click="handleRemoveCardButtonClick()"
        :disabled="state.isCardSelecting"
      >
        Добавить карту
      </AppButton>
    </div>
  </BottomDrawer>

  <BottomDrawer
    :is-shown="state.shownDeleteCard"
    @close="state.shownDeleteCard = false"
    :closeOnClickAway="false"
  >
    <div
      v-if="state.shownDeleteCard"
      style="display: flex; flex-direction: column; gap: 8px; padding: 16px; align-items: center;"
    >
      <div
        style="display: flex; width: 80px; height: 80px; background: #2B2B2B; align-items: center; justify-content: center; border-radius: 50%"
      >
        <component
          :is="icons.warning"
        />
      </div>
      <Typography
        variant="v20-700"
        center
      >
        Удалить карту?
      </Typography>
      <Typography
        variant="v14-500"
        center
        color="#D3D2D2"
      >
        Вы действительно хотите удалить
        карту •• {{ state.shownDeleteCard.masked_pan.slice(-4) }}? Это действие нельзя
        будет отменить.
      </Typography>
    </div>

    <div class="buttons2">
      <AppButton
        full-width
        style="margin-top: 16px"
        variant="primary"
        @click="state.shownDeleteCard = false"
        :disabled="state.isDeleting"
      >
        Отмена
      </AppButton>
      <AppButton
        full-width
        style="margin-top: 16px"
        variant="secondary"
        @click="deleteCard(state.shownDeleteCard)"
        :disabled="state.isDeleting"
        :loading="state.isDeleting"
      >
        Удалить
      </AppButton>
    </div>
  </BottomDrawer>

</template>

<script setup>
// TODO надо доработать это окно и окно PaymentResult
import BottomDrawer from '@/components/BottomDrawer.vue'
import {onMounted, onUnmounted, reactive, watch} from 'vue'
import AppButton from '@/components/UI/AppButton.vue'
import Typography from '@/components/UI/Typography.vue'
import store from '@/store/store.js'
import {router} from '@/router/router.js'
import {paymentStatuses} from '@/configs/subscriptionStatuses.js'
import {appAxios} from '@/axios.js'
import {icons} from '@/assets/icon/icons.js'
import {openPaymentUrl} from '@/utils/openPaymentUrl.js'

const props = defineProps({
  data: {
    type: Object,
    default: {},
  }
})

const state = reactive({
  isSubscriptionLoading: false,
  isNewPayLoading: false,
  isShown: false,
  loading: false,
  pan: '',

  cards: store.state.user.profile.cards ?? [],
  cardSelected: (store.state.user.profile.cards ?? []).find(c => c.is_default_for_autopay),

  isCardSelecting: false,
  isDeleting: false,
  shownPaymentsCards: false,
  shownDeleteCard: false,
})

onMounted(() => {
  const card = (store.state.user.profile.cards ?? []).find(c => c.is_default_for_autopay)
  state.pan = card?.masked_pan?.slice(-4)

  setTimeout(() => {
    state.isShown = true
  }, 50)
})

async function deleteCard(card) {
  state.isDeleting = true

  if((store.state.user.profile.cards ?? []).length === 1) {
    router.push({name: 'SubscriptionControlCancel'})
    return
  }

  const res = await appAxios.cards.delete(card.id)

  const newCardList = res.data
  await store.dispatch('user/updateProfile', {
    cards: newCardList,
  })
  state.cards = newCardList
  if(newCardList.length === 0) {
    state.isCardSelecting = false
    state.shownPaymentsCards = false
    state.cardSelected = null
  }
  state.isDeleting = false
  state.shownDeleteCard = false
}

async function selectCard() {
  state.isCardSelecting = true
  await appAxios.cards.setDefaultCard(state.cardSelected.id)

  state.cards.forEach(card => {
    card.is_default_for_autopay = state.cardSelected.id === card.id
  })

  state.isCardSelecting = false
  state.shownPaymentsCards = false
}

async function addCard() {
  state.cardSelected = false
  state.shownPaymentsCards = false
}

async function getSubscription() {
  // Telegram откроет ссылку оплаты, только если с нажатия прошло меньше ~10 секунд
  const startedAt = Date.now()
  try {
    const res = await appAxios.subscription.init(
      props.data.subscriptionPrice.id,
      store.state.user.directories.payment_type_list.at(0).id,
      undefined,
      undefined,
      state.cardSelected ? state.cardSelected.id : undefined,
    )
    if (!res.data.payment.payment_url) {
      if (res.data.payment.status === paymentStatuses.pending || res.data.payment.status === paymentStatuses.success) {
        store.commit('user/upsertSubscription', res.data.subscription)
        await router.push({name: 'SubscriptionControl'})
        return
      }

      if (res.data.payment.status === "failed") {
        // todo?
        const card = state.cardSelected
        state.pan = card?.masked_pan?.slice(-4)

        state.isSubscriptionLoading = false
        return
      } else {
        throw new Error('bad payment link')
      }
    }
    await openPaymentUrl({
      url: res.data.payment.payment_url,
      paymentId: res.data.payment.id,
      startedAt,
    })
  } catch (error) {
    throw error
  }
}

async function handlePaymentReTry() {
  state.loading = true
  state.isSubscriptionLoading = true
  await getSubscription()
  state.isSubscriptionLoading = false
  state.loading = false
}

function close() {
  state.isShown = false
  store.dispatch('app/setMessageComponent', null)
}

async function handleRemoveCardButtonClick() {
  state.loading = true
  state.isNewPayLoading = true

  state.cardSelected = undefined

  await getSubscription()

  state.isNewPayLoading = false
  state.loading = false
}

</script>

<style lang="scss" scoped>

.modal-divider {
  width: 100%;
  height: 1px;
  background: var(--app-bar-border-color);
  margin: 16px 0;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  .gradient {
    position: absolute;
    width: 224px;
    height: 224px;
    left: -50%;
    top: -50%;

    &.success {
      background: radial-gradient(rgba(86, 231, 118, 0.35) 0%, rgba(88, 234, 120, 0.05) 25%, rgba(0, 0, 0, 0) 50%);
    }

    &.pending {
      background: radial-gradient(rgb(255, 153, 0, 0.35) 0%, rgba(255, 153, 0, 0.06) 25%, rgba(0, 0, 0, 0) 50%);
    }

    &.failed {
      background: radial-gradient(rgb(255, 48, 58, 0.35) 0%, rgba(255, 48, 58, 0.06) 25%, rgba(0, 0, 0, 0) 50%);
    }
  }

  .successIcon {
    position: relative;
    background-image: url("@/assets/icons/bigSuccess.svg");
    height: 112px;
    width: 112px;
  }

  .pendingIcon {
    position: relative;
    background-image: url("@/assets/icons/bigPending.svg");
    height: 112px;
    width: 112px;
  }

  .failedIcon {
    position: relative;
    background-image: url("@/assets/icons/bigFailed.svg");
    height: 112px;
    width: 112px;
  }
}

/* */


.green {
  margin-top: 1px;
  background: #20B537;
  border-radius: 20px;
  padding: 2px 6px;
}

.gray {
  background: #222222;
  margin: 0 -16px;
  padding: 16px;
}

.delimiter {
  width: 100%;
  margin: 16px 0;
  border: 1px solid #2B2B2B;
}

.selectCard {
  .cardItem:not(:last-child) {
    border-bottom: 1px solid #303030;
  }
  overflow: auto;
  max-height: calc(100dvh - 240px);
}

.check {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  border: 2px solid #A6A5A5;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  &.checked {
    border-color: #CF2E2E;
    background: #CF2E2E;
  }
}


</style>
